/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2021, Zumper
 */

import { EVENT_NAMES, PROP_NAMES, track } from '@zcode/mixpanel'
import { getCommonProps } from '../helpers/getCommonProps'

export const mixpanelSwitchLeaseLength =
  ({ leaseLength, pageName, sectionName }) =>
  (dispatch, getState) => {
    const state = getState()
    const payload = {
      ...getCommonProps({ state, pageName, event: EVENT_NAMES.VIEW_PAGE }),
      [PROP_NAMES.SECTION]: sectionName,
      [PROP_NAMES.LEASE_LENGTH_TYPE]: leaseLength,
    }
    track({ event: EVENT_NAMES.SWITCH_LEASE_LENGTH, payload })
  }
